<template>
  <div>
    <a-row :gutter="[20, 0]" style="padding: 20px 0px 0">
      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Nome completo</label>
          <a-input
            class="travel-input"
            placeholder="Escreva..."
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_name${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">CPF</label>
          <a-input
            class="travel-input"
            placeholder="Escreva..."
            v-mask="'###.###.###-##'"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_CPF${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Celular</label>
          <a-input
            class="travel-input"
            placeholder="Escreva..."
            v-mask="'(##) # ####-####'"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_mobile_phone${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Telefone fixo</label>
          <a-input
            class="travel-input"
            placeholder="Escreva..."
            v-mask="'(##) ####-####'"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_phone${keySuffix}`,
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">CEP</label>
          <a-input
            class="travel-input"
            placeholder="CEP"
            v-mask="'#####-###'"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_CEP${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
            @change="getLocation"
          >
            <a-icon slot="prefix" type="field-svg" />
            <a-icon v-if="cepLoading" slot="suffix" type="loading" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="8">
        <a-form-item>
          <label :class="'filled'">Logradouro</label>
          <a-input
            class="travel-input"
            placeholder="Logradouro"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_location_street${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="4">
        <a-form-item>
          <label :class="'filled'">Número</label>
          <a-input
            type="number"
            class="travel-input"
            placeholder="Número"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_location_number${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Complemento</label>
          <a-input
            class="travel-input"
            placeholder="Complemento"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_location_complement${keySuffix}`,
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Bairro</label>
          <a-input
            class="travel-input"
            placeholder="Bairro"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_location_neighborhood${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Cidade</label>
          <a-input
            class="travel-input"
            placeholder="Cidade"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_location_city${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="field-svg" />
          </a-input>
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <a-form-item>
          <label :class="'filled'">Estado</label>
          <a-select
            class="travel-input"
            show-search
            placeholder="ES"
            v-decorator="[
              `payment_methods_credit_card_owner_${cardID}_location_state${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) of states"
              :key="index"
              :value="item.initials"
            >
              {{ item.initials.toUpperCase() }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import states from "@/json/states.json";
import axios from "axios";

export default {
  name: "CreditCardThirdPartyDataCollapse",
  props: {
    tempContract: Object,
    form: Object,
    cardID: Number,
    keyPrefix: {
      type: String,
      default: "",
    },
    keySuffix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      states,
      cepLoading: false,
    };
  },
  mounted() {
    this.setCreditCardOwnerFields();
  },
  methods: {
    setCreditCardOwnerFields() {
      this.form.setFieldsValue({
        [`payment_methods_credit_card_owner_${this.cardID}_name${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_name${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_CPF${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_CPF${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_mobile_phone${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_mobile_phone${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_phone${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_phone${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_CEP${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_CEP${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_location_street${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_location_street${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_location_number${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_location_number${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_location_complement${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_location_complement${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_location_neighborhood${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_location_neighborhood${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_location_city${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_location_city${this.keySuffix}`
          ],
        [`payment_methods_credit_card_owner_${this.cardID}_location_state${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_credit_card_owner_${this.cardID}_location_state${this.keySuffix}`
          ],
      });
    },
    getLocation() {
      setTimeout(() => {
        if (
          this.form.getFieldValue(
            `payment_methods_credit_card_owner_${this.cardID}_CEP${this.keySuffix}`
          )
        ) {
          if (
            this.form
              .getFieldValue(
                `payment_methods_credit_card_owner_${this.cardID}_CEP${this.keySuffix}`
              )
              .replace("-", "").length == 8
          ) {
            this.cepLoading = true;
            axios
              .get(
                "https://viacep.com.br/ws/" +
                  this.form.getFieldValue(
                    `payment_methods_credit_card_owner_${this.cardID}_CEP${this.keySuffix}`
                  ) +
                  "/json/"
              )
              .then(({ data }) => {
                this.cepLoading = false;
                this.form.setFieldsValue({
                  [`payment_methods_credit_card_owner_${this.cardID}_location_street${this.keySuffix}`]:
                    data.logradouro.toUpperCase(),
                });

                this.form.setFieldsValue({
                  [`payment_methods_credit_card_owner_${this.cardID}_location_state${this.keySuffix}`]:
                    data.uf,
                });

                this.form.setFieldsValue({
                  [`payment_methods_credit_card_owner_${this.cardID}_location_city${this.keySuffix}`]:
                    data.localidade.toUpperCase(),
                });

                this.form.setFieldsValue({
                  [`payment_methods_credit_card_owner_${this.cardID}_location_neighborhood${this.keySuffix}`]:
                    data.bairro.toUpperCase(),
                });
              })
              .catch(({ response }) => {
                response;
                this.$message.error(
                  "Houve um problema ao recuperar a localização."
                );
                this.cepLoading = false;
              });
          }
        }
      }, 110);
    },
  },
};
</script>

<style scoped lang="scss">
label {
  position: absolute;
  z-index: 4;
  font-size: 10px;
  font-weight: 500;
  color: #ccc;
  transition: 0.3s;
  opacity: 0;
  top: 13px;
  left: 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  &.filled {
    top: -16px;
    opacity: 1 !important;
  }
}
</style>
